import React from 'react';
import { connect } from 'react-redux';

import classes from './FareRules.scss';
import Spinner from '../../../../../UI/Spinner/Spinner';
import HeadingH4 from '../../../../../UI/Headings/HeadingH4/HeadingH4';

import FareRulesItem from './FareRulesItem/FareRulesItem';
import noFareRulesImage from './img/no-fare-rules.png';
import { toggleRoundTripFareRules } from '../../../../../../store/actions/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const fareRules = (props) => {

    let fareRules = <Spinner/>;
    if (props.rules !== null || undefined || '') {
        
        let fRules = null;
        
        if (props.isIntFlight) {
            if(props.success) {
                fRules = props.rules[0];
            }
        } else {
            fRules = props.rules;
        }

        if (props.isIntFlight) {
            if(props.success) {
                fareRules = (
                    <div className={`${props.isIntRoundTrip ? 'pl-0 pr-0 pt-4 pb-4' : 'pl-5 pr-5 phone-pl-4 phone-pr-4'}`}>
                        <div className={`${classes.FareRulesDetails} u-width100Percent u-height100Percent`}>
                            <div className={`pl-2 pr-2 pb-0 pt-0 mb-1`}>
                                <HeadingH4 size={13} weight="Regular" color="Dark">Cancellation Fee *</HeadingH4>
                            </div>
                            <FareRulesItem type='Before Departure' amount={fRules.ptc.ADT.CNFBD.amt} />
                            <FareRulesItem type='No-Show' amount={fRules.ptc.ADT.CNFNS.amt} />
                            <FareRulesItem type='After Departure' amount={fRules.ptc.ADT.CNFAD.amt} />
                        </div>
                        <div className={`${classes.FareRulesDetails} u-width100Percent u-height100Percent`}>
                            <div className={`pl-2 pr-2 pb-0 pt-0 mb-1`}>
                                <HeadingH4 size={13} weight="Regular" color="Dark">Change Fee *</HeadingH4>
                                <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>(modification of date/flight no./same city airports or transporting airlines)</h5>
                            </div>
                            <FareRulesItem type='Before Departure' amount={fRules.ptc.ADT.CHFBD.amt} />
                            <FareRulesItem type='No-Show' amount={fRules.ptc.ADT.CHFNS.amt} />
                            <FareRulesItem type='After Departure' amount={fRules.ptc.ADT.CHFAD.amt} />
                        </div>
                        <div className={`${classes.FareRulesDetails} u-width100Percent u-height100Percent`}>
                            <div className={`pl-2 pr-2 pb-0 pt-0 mb-1`}>
                                <HeadingH4 size={13} weight="Regular" color="Dark">Yatra Service Fee (YSF)</HeadingH4>
                                <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>(charged per passenger in addition to airline fee as applicable)</h5>
                            </div>
                            <FareRulesItem type='Offline Cancellation Service Fee' amount={'2,250'} />
                            <FareRulesItem type='Online Cancellation Service Fee' amount={'2,250'} />
                            <FareRulesItem type='Rescheduling Service Fee' amount={'1,250'} />
                        </div>
                    </div>
                );
            } else {
                fareRules = 
                <div>
                    <div className={`u-textAlignCenter`}>
                        <img src={noFareRulesImage} alt='No Fare Rules' className={`u-width75`}/>
                    </div>
                    <div className={`mb-2 u-textAlignCenter`}>
                        <HeadingH4 size={20} weight="Medium" color="Dark">No Fare Rules!</HeadingH4>
                    </div>
                    <p className={`u-fontSize13 u-fontWeightRegular u-textColorNormal u-textAlignCenter`}>Sorry no fare rules are found for this flight</p>
                </div>
            }
        } else {
            let isDomRT = false;
            if (props.type === 'domRT') {
                isDomRT = true;
            }
            fareRules = (
                <React.Fragment>
                    {
                        props.type === 'domRT' ? <div className={`pl-5 pr-5 pt-5 u-flex justify-content-between align-items-center`}>
                        <p className={`u-textColorDark u-fontSize13 u-fontWeightMedium`}>Fare Rules</p>
                        <div className={`u-cursorPointer u-size15x15 u-flex align-items-center`} onClick={() => props.onToggleRoundTripFareRules()}>
                            <FontAwesomeIcon icon="times" color="#666" size="lg" />
                        </div>
                    </div> : null
                    }
                    <div className={`${props.isIntRoundTrip ? 'pl-0 pr-0 pt-4 pb-4' : props.type === 'domRT' ? 'pl-4 pr-4 pt-5 pb-5' : 'pl-8 pr-8 phone-pl-4 phone-pr-4'}`}>
                        <div className={`${classes.FareRulesDetails} u-borderNormal u-width100Percent u-height100Percent`}>
                                <FareRulesItem
                                isDomRT={isDomRT} 
                                type={
                                    <React.Fragment>
                                        <HeadingH4 size={13} weight="Medium" color="Dark">Time</HeadingH4>
                                        <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>DURATION (Prior to the date/time of departure)	</h5>
                                    </React.Fragment>
                                } 
                                amount={
                                    <React.Fragment>
                                        <HeadingH4 size={13} weight="Medium" color="Dark">Airline Cancellation Fee *</HeadingH4>
                                        <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>PER PASSENGER</h5>
                                    </React.Fragment>} />
                            {
                                fRules.ris.cslab && fRules.ris.cslab.map((rule, index) => {
                                    let left = null;
                                    let right = null;

                                    if (fRules.ris.cslab.length === (index + 1)) {
                                        return <FareRulesItem
                                            key={index.toString()}
                                            isDomRT={isDomRT}
                                            type={`> ${parseInt(rule.sh) > 24 ? parseInt(rule.sh) / 24 + ' days' : parseInt(rule.sh) + ' hours'}`} 
                                            amount={<p>{parseInt(rule.amt, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(rule.amt, 10)) ? rule.amt : parseInt(rule.amt, 10).toLocaleString()}</p>} />;
                                    }
                                    
                                    if (parseInt(rule.sh) > 24) {
                                        left = parseInt(rule.sh) / 24 + ' days';
                                    } else { left = rule.sh + (rule.sh >= 1 ? ' hours' : ' hour'); }

                                    if (parseInt(rule.eh) > 24) {
                                        right = parseInt(rule.eh) / 24 + ' days';
                                    } else { right = rule.eh + (rule.eh >= 1 ? ' hours' : ' hour'); }
                                    return <FareRulesItem
                                        key={index.toString()}
                                        isDomRT={isDomRT}
                                        type={`${left} to ${right}`} 
                                        amount={<p>{parseInt(rule.amt, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(rule.amt, 10)) ? rule.amt : parseInt(rule.amt, 10).toLocaleString()}</p>} />;
                                })
                            }
                        </div>
                        <div className={`${classes.FareRulesDetails} u-borderNormal u-width100Percent u-height100Percent`}>
                            <FareRulesItem 
                                isDomRT={isDomRT}
                                type={
                                    <React.Fragment>
                                        <HeadingH4 size={13} weight="Medium" color="Dark">Time</HeadingH4>
                                        <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>DURATION (Prior to the date/time of departure)	</h5>
                                    </React.Fragment> } 
                                amount={
                                    <React.Fragment>
                                        <HeadingH4 size={13} weight="Medium" color="Dark">Airline Date Change Fee *</HeadingH4>
                                        <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>PER PASSENGER</h5>
                                    </React.Fragment>} />
                            {
                                fRules.ris.reslab && fRules.ris.reslab.map((rule, index) => {
                                    let left = null;
                                    let right = null;

                                    if (fRules.ris.reslab.length === (index + 1)) {
                                        return <FareRulesItem
                                            key={index.toString()}
                                            isDomRT={isDomRT}
                                            type={`> ${parseInt(rule.sh) > 24 ? parseInt(rule.sh) / 24 + ' days' : parseInt(rule.sh) + ' hours'}`} 
                                            amount={<p>{parseInt(rule.amt, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(rule.amt, 10)) ? rule.amt : parseInt(rule.amt, 10).toLocaleString()}</p>} />;
                                    }
                                    
                                    if (parseInt(rule.sh) > 24) {
                                        left = parseInt(rule.sh) / 24 + ' days';
                                    } else { left = rule.sh + (rule.sh >= 1 ? ' hours' : ' hour'); }

                                    if (parseInt(rule.eh) > 24) {
                                        right = parseInt(rule.eh) / 24 + ' days';
                                    } else { right = rule.eh + (rule.eh >= 1 ? ' hours' : ' hour'); }
                                    
                                    return <FareRulesItem
                                        key={index.toString()} 
                                        isDomRT={isDomRT}
                                        type={`${left} to ${right}`} 
                                        amount={<p>{parseInt(rule.amt, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(rule.amt, 10)) ? rule.amt : parseInt(rule.amt, 10).toLocaleString()}</p>} />;
                                })
                            }
                        </div>
                        <div className={`${classes.FareRulesDetails} u-borderNormal u-width100Percent u-height100Percent`}>
                            <FareRulesItem
                                fullWidth
                                isDomRT={isDomRT}
                                type={ <React.Fragment>
                                        <HeadingH4 size={13} weight="Medium" color="Dark">Yatra Service Fee (YSF)</HeadingH4>
                                        <h5 className={`u-fontWeightRegular u-textColorLight u-fontSize11`}>(charged per passenger in addition to airline fee as applicable)</h5>
                                    </React.Fragment> } />
                            <FareRulesItem
                                isDomRT={isDomRT} 
                                type='Online Cancellation Service Fee' amount={<p>{parseInt(fRules.yf, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(fRules.yf, 10)) ? fRules.yf : parseInt(fRules.yf, 10).toLocaleString()}</p>} />
                            <FareRulesItem 
                                isDomRT={isDomRT}
                                type='Offline Cancellation Service Fee' amount={<p>{parseInt(fRules.yof, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(fRules.yof, 10)) ? fRules.yof : parseInt(fRules.yof, 10).toLocaleString()}</p>} />
                            <FareRulesItem 
                                isDomRT={isDomRT}
                                type='Online Rescheduling Service Fee'  amount={<p>{parseInt(fRules.ycf, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(fRules.ycf, 10)) ? fRules.ycf : parseInt(fRules.ycf, 10).toLocaleString()}</p>} />
                            <FareRulesItem 
                                isDomRT={isDomRT}
                                type='Offline Rescheduling Service Fee' amount={<p>{parseInt(fRules.ycof, 10) > 0 ? <span>&#8377;</span> : null }{isNaN(parseInt(fRules.ycof, 10)) ? fRules.ycof : parseInt(fRules.ycof, 10).toLocaleString()}</p>} />
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }

    return (
        <div>
            {fareRules}        
        </div>
    );
}

const mapStateToProps = state => {
    return {
        success: state.fareRules.success
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleRoundTripFareRules: () => dispatch(toggleRoundTripFareRules())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(fareRules);


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FareInfo/FareRules/FareRules.js